import { DOCK_LABELS } from "../../shared/constants/pageAgentLabels";

interface AgentWorkingIndicatorProps {
  /** What Theragenie is doing right now: a tool's label, or "Thinking". */
  label: string;
}

/**
 * The unmistakable sign that a question is running: a spinner and what is happening now. Announced
 * politely, so a screen reader hears each step without being interrupted.
 */
export function AgentWorkingIndicator({ label }: AgentWorkingIndicatorProps) {
  return (
    <p className="pa-working" role="status" aria-live="polite">
      <span className="pa-spinner" aria-hidden="true" />
      <span className="pa-working-text">{DOCK_LABELS.workingPrefix} — {label}…</span>
    </p>
  );
}
